module.exports = __webpack_public_path__ + "img/work-from-home.f004bd7d.png";